import { Link } from "react-router-dom";

export default function MarketingFooter() {
  return (
    <footer className="border-t border-[#D8CFB9] bg-[#E5DECC] mt-24" data-testid="marketing-footer">
      <div className="max-w-6xl mx-auto px-6 md:px-8 py-12 grid gap-8 md:grid-cols-4 text-sm text-[#59605C]">
        <div>
          <div className="flex items-baseline gap-2.5 mb-4">
            <span className="w-9 h-9 self-center rounded-full bg-[#4A6148] flex items-center justify-center text-white font-wordmark tracking-tight text-[11px] font-bold leading-none">
              WYB
            </span>
            <span className="font-wordmark text-[#2C302E] text-lg leading-none tracking-tight">
              WhatsYourBalance<span className="font-wordmark-italic text-[#4A6148] text-[0.72em] ml-[1px]">.com</span>
            </span>
          </div>
          <p className="leading-relaxed">
            A calmer way to see if your paycheck covers your bills. No spreadsheets. No budget categories.
          </p>
        </div>
        <div>
          <div className="text-[#2C302E] font-medium mb-3">Product</div>
          <ul className="space-y-2">
            <li><Link to="/" className="hover:text-[#4A6148]" data-testid="footer-link-home">Home</Link></li>
            <li><Link to="/pricing" className="hover:text-[#4A6148]" data-testid="footer-link-pricing">Pricing</Link></li>
            <li><Link to="/faq" className="hover:text-[#4A6148]" data-testid="footer-link-faq">FAQ</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-[#2C302E] font-medium mb-3">Get started</div>
          <ul className="space-y-2">
            <li><Link to="/signup" className="hover:text-[#4A6148]" data-testid="footer-link-signup">Start free trial</Link></li>
            <li><Link to="/login" className="hover:text-[#4A6148]" data-testid="footer-link-login">Log in</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-[#2C302E] font-medium mb-3">Legal</div>
          <ul className="space-y-2">
            <li><Link to="/terms" className="hover:text-[#4A6148]" data-testid="footer-link-terms">Terms of Service</Link></li>
            <li><Link to="/privacy" className="hover:text-[#4A6148]" data-testid="footer-link-privacy">Privacy Policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#EBE6E0] py-6 text-center text-xs text-[#8A918D]">
        © {new Date().getFullYear()} What&rsquo;s Your Balance? Made with care.
      </div>
    </footer>
  );
}
